import React from 'react';

function Dashboard() {
  return (
    <section className="section dashboard-section">
      <div className="container">
        <div className="dashboard-wrapper">
          <h2 className="dashboard-main-title">Live School Dashboard</h2>
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <h3 className="dashboard-card-title">School Dashboard</h3>
              <span className="dashboard-card-date">Today, Jan 19 2026</span>
            </div>
            <div className="dashboard-stats-row">
              <div className="dashboard-stat-box">
                <h4 className="dashboard-stat-number">1,247</h4>
                <p className="dashboard-stat-label">TOTAL STUDENTS</p>
              </div>
              <div className="dashboard-stat-box">
                <h4 className="dashboard-stat-number">₹12.5L</h4>
                <p className="dashboard-stat-label">FEES COLLECTED</p>
              </div>
            </div>
            <div className="dashboard-activity-box">
              <h4 className="dashboard-activity-title">Recent Activity</h4>
              <div className="dashboard-activity-item">
                <span className="dashboard-dot green-dot"></span>
                <span className="dashboard-activity-text">New admission: Rahul Sharma (Class 6)</span>
              </div>
              <div className="dashboard-activity-item">
                <span className="dashboard-dot blue-dot"></span>
                <span className="dashboard-activity-text">Fee payment received: ₹25,000</span>
              </div>
              <div className="dashboard-activity-item last">
                <span className="dashboard-dot orange-dot"></span>
                <span className="dashboard-activity-text">Exam schedule updated for Class 10</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Dashboard;
